export const NamesDB = {
  cardId: 'CardId',
  pan: 'PAN',
  cardholder: 'Cardholder',
  jobName: 'JobName',
  productName: 'ProductName',
  branchName: 'Name',
  deviceName: 'DeviceName',
  deviceTypeName: 'DeviceTypeName',
  sn: 'SN',
  updateTime: 'UpdateTime',
  link: 'Link',
  deviceStatus: 'DeviceStatusId',
  lastActionDateTime: 'LastActionDateTime',
  message: 'Message',
  bankName: 'BankName',
  statusName: 'SortIndex',
  priorityName: 'CardPriorityId',
  address: 'Address',
  kioskStatus: 'KioskStatus',
  softwareStatus: 'SoftwareStatus',
  logDateTime: 'LogDateTime',
  logMessage: 'LogMessage',
  name: 'Name',
};